<template>
  <div class="w-full flex flex-wrap justify-end gap-[4px]">
    <BButton
      variant="outline-primary"
      class="w-fit shrink-0 filter-button outlined-filter-button"
      @click="$bvModal.show('modal-download-claim')"
    >
      <div class="d-flex align-items-center">
        Download
        <span class="k-document-download text-xl ml-[5px]" />
      </div>
    </BButton>
    <BButton
      id="claim-type"
      variant="flat-dark"
      class="w-fit shrink-0 filter-button outlined-filter-button"
    >
      <div
        class="flex flex-row-reverse gap-[24px] items-center justify-between h-full w-full"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/arrow-down-light.svg"
          alt="arrow-down"
        >
        <span class="leading-[1.2] truncate">{{
          filterClaimType.label === 'Semua' ? 'Jenis Claim' : filterClaimType.label
        }}</span>
      </div>
    </BButton>
    <BPopover
      ref="filter-claim-type"
      target="claim-type"
      triggers="focus"
      placement="bottom"
      custom-class="wrapper-shipment"
    >
      <b-list-group>
        <b-list-group-item
          v-for="claim in statusType"
          :key="claim.id"
          class="cursor-pointer"
          :active="filterClaimType.label === claim.label"
          @click="changeFilterClaimType(claim)"
        >
          {{ claim.label }}
        </b-list-group-item>
      </b-list-group>
    </BPopover>

    <DateRangePicker
      ref="picker"
      v-model="dateRange"
      :locale-data="locale"
      :ranges="ranges"
      opens="center"
      class="w-[130px] shrink-0 filter-button outlined-filter-button"
      control-container-class="periode-datepicker"
      :max-date="new Date()"
    >
      <template v-slot:input>
        <div
          class="flex flex-row-reverse items-center justify-between h-full w-full truncate ..."
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/arrow-down-light.svg"
            alt="arrow-down"
          >
          <span class="text-black">Periode</span>
        </div>
      </template>
    </DateRangePicker>

    <BButton
      id="popoverShipment"
      variant="flat-dark"
      class="w-[130px] shrink-0 filter-button outlined-filter-button"
    >
      <div
        class="flex flex-row-reverse items-center justify-between h-full w-full"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/arrow-down-light.svg"
          alt="arrow-down"
        >
        <span class="leading-[1.2]">{{ filterShipment.shipping_name === 'Semua' ? 'Ekspedisi' : filterShipment.shipping_name }}</span>
      </div>
    </BButton>
    <BPopover
      ref="filter-shipping"
      target="popoverShipment"
      triggers="focus"
      placement="bottom"
      custom-class="wrapper-shipment"
    >
      <b-list-group>
        <b-list-group-item
          v-for="(item, index) in expeditionList"
          :key="index"
          class="cursor-pointer"
          :active="item.shipping_name === filterShipment.shipping_name"
          @click="filterByShipment(item)"
        >
          {{ item.shipping_name }}
        </b-list-group-item>
      </b-list-group>
    </BPopover>

    <BButton
      id="claim-status"
      variant="flat-dark"
      class="w-fit shrink-0 filter-button outlined-filter-button"
    >
      <div
        class="flex flex-row-reverse gap-[24px] items-center justify-between h-full w-full"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/arrow-down-light.svg"
          alt="arrow-down"
        >
        <span class="leading-[1.2] truncate">{{
          filterClaimStatus.label === 'Semua' ? 'Status Pengajuan' : filterClaimStatus.label
        }}</span>
      </div>
    </BButton>
    <BPopover
      ref="filter-claim-status"
      target="claim-status"
      triggers="focus"
      placement="bottom"
      custom-class="wrapper-shipment"
    >
      <b-list-group>
        <b-list-group-item
          v-for="claim in statusClaims"
          :key="claim.id"
          class="cursor-pointer"
          :active="filterClaimStatus.label === claim.label"
          @click="changeFilterClaimStatus(claim)"
        >
          {{ claim.label }}
        </b-list-group-item>
      </b-list-group>
    </BPopover>

    <BFormInput
      v-model="search"
      placeholder="Cari No Resi/ No Tiket"
      class="filter-button search-field"
      @input="searchData"
    />
    <ModalDownloadClaim />
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { mapState } from 'vuex'
import { DAY_MONTH_YEAR, TIME } from '@/libs/formatDate'
import { today, firstDateOfMonth, formatYmd } from '@/store/helpers'
import ModalDownloadClaim from './ModalDownloadClaim.vue'
import { listStatusType, listStatusClaims, filterDate } from './config'

export default {
  components: {
    DateRangePicker,
    ModalDownloadClaim,
  },
  data() {
    return {
      DAY_MONTH_YEAR,
      TIME,
      formatYmd,
      filterClaimType: { id: '', label: 'Semua' },
      statusType: listStatusType,
      filterClaimStatus: { id: '', label: 'Semua' },
      statusClaims: listStatusClaims,
      ranges: filterDate.ranges,
      dateRange: {
        startDate: firstDateOfMonth,
        endDate: today,
      },
      locale: filterDate.locale,
      filterShipment: { id: '', image_path: '', shipping_name: 'Semua' },
      expeditionList: [],
      search: '',
      params: {
        start_date: formatYmd(firstDateOfMonth),
        end_date: formatYmd(today),
      },
    }
  },
  computed: {
    ...mapState('filter', ['expedition']),
  },
  watch: {
    filterClaimType() {
      this.params.claim_type = this.filterClaimType.id
      this.updateParams()
    },
    dateRange() {
      this.params.start_date = formatYmd(this.dateRange.startDate)
      this.params.end_date = formatYmd(this.dateRange.endDate)
      this.updateParams()
    },
    filterShipment() {
      this.params.shipping = this.filterShipment.shipping_name === 'Semua' ? '' : this.filterShipment.shipping_name
      this.updateParams()
    },
    filterClaimStatus() {
      this.params.status_claim = this.filterClaimStatus.id
      this.updateParams()
    },
  },
  mounted() {
    if (this.expedition.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
    this.expeditionList = [{ id: '', image_path: '', shipping_name: 'Semua' }].concat(this.expedition)
    this.updateParams()
  },
  methods: {
    updateParams() {
      this.$emit('update:params', this.params)
    },
    changeFilterClaimType(nextValue) {
      this.filterClaimType = nextValue
      this.$refs['filter-claim-type'].$emit('close')
    },
    changeFilterClaimStatus(nextValue) {
      this.filterClaimStatus = nextValue
      this.$refs['filter-claim-status'].$emit('close')
    },
    filterByShipment(nextValue) {
      this.filterShipment = nextValue
      this.$refs['filter-shipping'].$emit('close')
    },
    searchData: _.debounce(function search() {
      this.resetFilter()
      this.params = {}
      this.params.search = this.search
      this.updateParams()
    }, 1000),
    resetFilter() {
      this.filterClaimType = { id: '', label: 'Semua' }
      this.filterClaimStatus = { id: '', label: 'Semua' }
      this.filterShipment = { id: '', image_path: '', shipping_name: 'Semua' }
      this.dateRange.startDate = ''
      this.dateRange.endDate = ''
    },
    download() {
      this.$bvModal.show('modal-download-claim')
    },
  },
}
</script>

<style>
.wrapper-shipment > .popover-body {
  padding: 0 !important;
  min-width: 200px;
}

.filter-button {
  padding: 6px 12px !important;
  border-radius: 8px !important;
}

.outlined-filter-button {
  border: 1px solid rgb(194, 194, 194);
}

.search-field {
  width: 220px !important;
  flex-shrink: 0;
}

@media screen and (min-width: 1340px) {
  .search-field {
    width: 308px !important;
  }
}
</style>
